/* A refused token still answers 200, with a script that calls handleSocialLoginFail, so the
   status says nothing about the outcome. Only the success page names this callback.
   LoginBaseController::getSocialLoginSuccessPageContentsWindow writes it. */
export const LOGIN_SUCCESS_MARKER = 'handleSocialLoginSuccess';

export function isLoginAccepted(body: unknown): boolean {
    return String(body).includes(LOGIN_SUCCESS_MARKER);
}
